import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewChild,
} from '@angular/core';
import { PermissionService } from 'src/app/utils/permission.service';
import { StateTypes } from '../../models/common';

@Component({
  selector: 'app-button-toggle-ui2',
  templateUrl: './button-toggle-ui2.component.html',
  styleUrls: ['./button-toggle-ui2.component.css'],
})
export class ButtonToggleUi2Component implements AfterViewInit, OnDestroy {
  @Input() btnClass = 'w-[200px]';
  @Input() buttons: StateTypes[] = [];
  @Output() stateEmit: EventEmitter<StateTypes['value']> = new EventEmitter();
  @Output() clickEmit: EventEmitter<any> = new EventEmitter();
  @Input() isDisabled: boolean = false;

  @ViewChild('scroller') private scroller?: ElementRef<HTMLDivElement>;

  /** Drive the mobile-only left/right scroll arrows. Hidden entirely — rather
   *  than shown-but-disabled — once there is nothing left to scroll that way. */
  public canScrollLeft = false;
  public canScrollRight = false;

  private resizeObserver?: ResizeObserver;

  constructor(private permissionsService: PermissionService) {}

  ngAfterViewInit(): void {
    this.updateScrollState();
    // Catches the tab count changing (permission-gated buttons) and viewport
    // or orientation changes — anything that alters scrollWidth vs
    // clientWidth — without a manual hook into *ngFor or a window resize
    // listener.
    if (this.scroller && 'ResizeObserver' in window) {
      this.resizeObserver = new ResizeObserver(() => this.updateScrollState());
      this.resizeObserver.observe(this.scroller.nativeElement);
    }
  }

  ngOnDestroy(): void {
    this.resizeObserver?.disconnect();
  }

  public hasPermission(perms: string[]) {
    return this.permissionsService.hasPermissionList(perms);
  }

  toggleActive(val: StateTypes['value']) {
    this.buttons.forEach((button) => {
      button.isActive = button.value === val;
    });
    this.stateEmit.emit(val);
    this.clickEmit.emit(val);
  }

  public scrollByAmount(delta: number): void {
    this.scroller?.nativeElement.scrollBy({ left: delta, behavior: 'smooth' });
  }

  /** A 1px slack on each side absorbs sub-pixel scroll rounding, so the arrows
   *  do not flicker in and out right at the scroll limits. */
  public updateScrollState(): void {
    const el = this.scroller?.nativeElement;
    if (!el) return;
    this.canScrollLeft = el.scrollLeft > 1;
    this.canScrollRight = el.scrollLeft + el.clientWidth < el.scrollWidth - 1;
  }
}
